import { Phone, Mail, MapPin, Facebook, Instagram, Clock, AlertCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { brand } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-[#101318] text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-[#e2001a] text-white font-display font-extrabold text-lg">A</span>
              <span className="font-display font-extrabold text-lg text-white leading-tight">{brand.name}</span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              {brand.tagline}. La tua officina di fiducia a Treviso: revisioni, tagliandi,
              meccanica, gomme, elettrauto e diagnostica.
            </p>
            <div className="flex gap-3 mt-5">
              <a href={brand.facebook} target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#e2001a] flex items-center justify-center transition-colors">
                <Facebook className="w-4 h-4" />
              </a>
              <a href={brand.instagram} target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#e2001a] flex items-center justify-center transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4">Servizi</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/#servizi" className="hover:text-[#e2001a] transition-colors">Revisioni ufficiali</a></li>
              <li><a href="/#servizi" className="hover:text-[#e2001a] transition-colors">Tagliandi e manutenzione</a></li>
              <li><a href="/#servizi" className="hover:text-[#e2001a] transition-colors">Riparazioni meccaniche</a></li>
              <li><a href="/#listino" className="hover:text-[#e2001a] transition-colors">Gommista</a></li>
              <li><a href="/#servizi" className="hover:text-[#e2001a] transition-colors">Elettrauto e diagnostica</a></li>
              <li><Link to="/auto" className="hover:text-[#e2001a] transition-colors">Auto in vendita</Link></li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-white font-semibold mb-4 flex items-center gap-2"><Clock className="w-4 h-4" /> Orari</h4>
            <ul className="space-y-1.5 text-sm text-gray-400">
              <li>Lun – Ven: 08:00 – 12:00 / 14:00 – 18:30</li>
              <li>Sabato: 08:00 – 12:00</li>
              <li>Domenica: Chiuso</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contatti</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-[#e2001a]" /> {brand.address}, {brand.city}</li>
              <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-[#e2001a]" /><a href={brand.phoneHref} className="hover:text-white">{brand.phone}</a></li>
              <li className="flex items-center gap-2"><AlertCircle className="w-4 h-4 text-[#e2001a]" /><a href={brand.emergencyHref} className="hover:text-white">{brand.emergency}</a></li>
              <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#e2001a]" /><a href={`mailto:${brand.email}`} className="hover:text-white">{brand.email}</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-gray-500">
          <p>© {new Date().getFullYear()} {brand.name}. Tutti i diritti riservati. — Sito dimostrativo.</p>
          <div className="flex gap-4">
            <a href="#" onClick={(e) => e.preventDefault()} className="hover:text-white">Privacy Policy</a>
            <a href="#" onClick={(e) => e.preventDefault()} className="hover:text-white">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
